import React, { useEffect, useState } from "react";
import SeoFields from "../../common/SEOFields";

const defaultValues = {
  name: "",
  slug: "",
  description: "",
  status: "ACTIVE",

  metaTitle: "",
  metaDescription: "",
  metaKeywords: "",
  metaImage: null,
  metaImagePreview: "",

  coverImage: null,
};

const BlogCategoryForm = ({
  category,
  initialValues,
  onSubmit,
  loading,
  errors = {},
  onCancel,
}) => {
  const [formData, setFormData] = useState({
    ...defaultValues,
    ...(initialValues || {}),
  });

  useEffect(() => {
    setFormData({
      ...defaultValues,
      ...(initialValues || {}),
    });
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      if (name === "name") {
        updated.metaTitle = value;
      }

      if (name === "description") {
        updated.metaDescription = value;
      }

      return updated;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      coverImage: formData.metaImage,
    };

    if (onSubmit) {
      onSubmit(payload);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card">
        <div className="card-body">
          

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div className="mb-3 h80">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                name="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter category name"
              />

              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>

              <textarea
                name="description"
                rows="4"
                className="form-control"
                value={formData.description}
                onChange={handleChange}
              />
            </div>
            {/* Status */}
            <div className="mb-3">
              <label className="form-label">Status</label>

              <select
                name="status"
                className="form-select"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="ACTIVE">Active</option>

                <option value="INACTIVE">Inactive</option>
              </select>
            </div>

            {/* SEO Fields */}
            <SeoFields
              formData={formData}
              setFormData={setFormData}
              handleChange={handleChange}
              errors={errors}
            />
            <div className="text-end">
              <button type="submit" className="btn btn-primary me-2" disabled={loading}>
                {loading ? "Saving..." : category?._id ? "Update" : "Submit"}
              </button>

              <button
                type="button"
                className="btn"
                style={{ backgroundColor: "#032B4D", color: "#fff" }}
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoryForm;
